module.exports = require('../../es/array/from');



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/features/array/from.js
// module id = 65
// module chunks = 0